import { render, staticRenderFns } from "./AchBranding.vue?vue&type=template&id=d195b6b4&scoped=true"
import script from "./AchBranding.vue?vue&type=script&lang=ts"
export * from "./AchBranding.vue?vue&type=script&lang=ts"
import style0 from "./AchBranding.vue?vue&type=style&index=0&id=d195b6b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d195b6b4",
  null
  
)

export default component.exports